import { render, staticRenderFns } from "./formRegion.vue?vue&type=template&id=62a2faf9&scoped=true"
import script from "./formRegion.vue?vue&type=script&lang=js"
export * from "./formRegion.vue?vue&type=script&lang=js"
import style0 from "./formRegion.vue?vue&type=style&index=0&id=62a2faf9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62a2faf9",
  null
  
)

export default component.exports